import { useState } from "react";
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Modal, Upload, message, Typography } from "antd";

import { getSignedS3DownloadUrl } from "api/fileUpload";
import { toLocaleString } from "utils/time";

const PcrUploadFileModal = ({
  isOpen,
  isUploadingFile,
  upload,
  onCancel,
  onSubmit,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [newFile, setNewFile] = useState();

  const handleDownloadClick = async () => {
    setIsDownloading(true);
    const fileUrl = await getSignedS3DownloadUrl("qpcr-uploads", upload?.id);
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = upload?.file_name;
        link.click();
        link.remove();
      })
      .catch((error) => console.error(error));

    setIsDownloading(false);
  };

  const handleUploadChange = (info) => {
    const file = info?.file;
    if (file?.status === "done") {
      setNewFile(file?.originFileObj || file);
    } else if (file?.status === "error") {
      message.error("Failed to upload file. Please try again.");
    }
  };

  return (
    <Modal
      title={
        <Typography.Title style={{ marginBottom: 0 }} level={4}>
          PCR Results File
        </Typography.Title>
      }
      className="qpcr-upload-file-modal"
      destroyOnClose={true}
      open={isOpen}
      onCancel={onCancel}
      footer={
        <div className="flex justify-between">
          <div>
            <Button
              size="small"
              className="mr-1"
              loading={isDownloading}
              onClick={handleDownloadClick}
            >
              Download Current File <DownloadOutlined />
            </Button>
            <Upload
              accept=".xlsx"
              maxCount={1}
              onChange={handleUploadChange}
              customRequest={({ onSuccess }) => onSuccess("ok")}
            >
              <Button size="small">
                Upload New File <UploadOutlined />
              </Button>
            </Upload>
          </div>
          <Button
            type="primary"
            size="small"
            disabled={!newFile}
            loading={isUploadingFile}
            onClick={() => onSubmit(upload, newFile)}
          >
            Submit
          </Button>
        </div>
      }
    >
      <p>{upload?.file_name}</p>
      <p className="text-sm">
        <i>Last Updated: {toLocaleString(upload?.updated_at)}</i>
      </p>
    </Modal>
  );
};

export default PcrUploadFileModal;
